import { useParams, Link } from "react-router-dom";
import { ShieldCheck, ArrowLeft } from "lucide-react";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    body: ["GetCerty ('we') is the data controller for the personal data you provide. We process your account details, property records and uploaded certificates solely to deliver the compliance-tracking service.",
      "Lawful basis: performance of our contract with you and our legitimate interest in providing a secure service. Certificates may contain third-party data (e.g. engineers); we process this as part of your records.",
      "Your data is encrypted at rest and in transit, and strictly isolated per account. We never sell your data.",
      "Your rights under UK GDPR: access, rectification, erasure, portability and objection. You can export or delete all your data at any time from Settings.",
      "Retention: we keep records for the life of your account. Deleting your account removes all associated data. Contact: info@getcerty.co.uk."]
  },
  terms: {
    title: "Terms of Service",
    body: ["By using GetCerty you agree to these terms. GetCerty is a compliance-tracking tool and does not constitute legal advice. You remain responsible for meeting your legal obligations as a landlord.",
      "Rule packs and reminders are provided for guidance and should be verified against official sources. We flag seeded rules as 'verify against official sources'.",
      "Subscriptions renew automatically unless cancelled. A 14-day free trial is offered with no card required.",
      "We may update the service and these terms. Continued use constitutes acceptance."]
  },
  cookies: {
    title: "Cookie Policy",
    body: ["We use strictly necessary cookies to keep you signed in and secure your session. These are always on.",
      "With your consent we may use analytics cookies to understand usage and improve GetCerty. You can choose 'Essential only' in the cookie banner.",
      "You can clear cookies in your browser at any time; doing so will sign you out."]
  },
};

export default function Legal() {
  const { kind } = useParams();
  const c = CONTENT[kind] || CONTENT.privacy;
  return (
    <div className="min-h-screen bg-background">
      <header className="h-16 flex items-center px-4 sm:px-6 bg-navy text-white">
        <Link to="/" className="flex items-center gap-2 font-heading font-extrabold text-lg"><span className="grid place-items-center h-8 w-8 rounded-lg bg-emerald-brand"><ShieldCheck size={18} /></span> GetCerty</Link>
      </header>
      <div className="max-w-2xl mx-auto px-4 py-10">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground mb-4 hover:text-foreground"><ArrowLeft size={16} /> Back</Link>
        <h1 className="font-heading text-3xl font-bold">{c.title}</h1>
        <p className="text-sm text-muted-foreground mt-1">Last updated {new Date().toLocaleDateString()}</p>
        <div className="mt-6 space-y-4 text-sm leading-relaxed text-foreground/90">{c.body.map((p, i) => <p key={i}>{p}</p>)}</div>
      </div>
    </div>
  );
}
